import React from 'react'

import httpsConfigurationApi from '../../HttpsConfigurationPage.api'

import PendingAcmeOrderForm from './PendingAcmeOrderForm/PendingAcmeOrderForm'
import TermsOfServiceForm from './TermsOfServiceForm/TermsOfServiceForm'

import styles from './CertificateFetchForm.css'

function CertificateFetchForm() {
  const {data: pendingAcmeOrder} =
    httpsConfigurationApi.endpoints.getPendingAcmeOrder.useQueryState()

  return (
    <div className={styles.fetchForm}>
      {pendingAcmeOrder != null ? (
        <PendingAcmeOrderForm pendingAcmeOrder={pendingAcmeOrder} />
      ) : (
        <TermsOfServiceForm />
      )}
    </div>
  )
}

export default CertificateFetchForm
